"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fontWeights = void 0;
exports.fontWeights = {
    fontWeight100: 100,
    fontWeight200: 200,
    fontWeight300: 300,
    fontWeight400: 400,
    fontWeight500: 500,
    fontWeight600: 600,
    fontWeight700: 700,
    fontWeight800: 800,
    fontWeight900: 900
};
